module.exports = __webpack_public_path__ + "static/media/Slide97.7cd1ad91.JPG";